/*
 * A component to be used for errors and other notifications
 * <p>
 *
 * @author lachezar.parvin
 * @author Gallagher Bassett IT
 * @author Copyright (c) 2020 Gallagher Bassett Services, Inc.
 *
 */

import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NotificationService } from 'app/shared/services/notification.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'reporter-notifications',
    templateUrl: './notifications.component.html',
    styleUrls: ['./notifications.component.scss'],
    standalone: false
})
export class NotificationsComponent implements OnInit, OnDestroy {
  private subscription: Subscription;
  notifications = [];

  @Input() clearOnNew = true;

  constructor(private notificationService: NotificationService) {}

  ngOnInit(): void {
    this.subscription = this.notificationService.notifications.subscribe((n) => {
        if (n === 'clear' && this.notifications.length) {
          this.notifications = [];
        } else if (n.type) {
          if (this.clearOnNew) {
            this.notifications = this.notifications.filter((item) => item.type !== n.type);
          }
          this.notifications.push(n);
        }
      }
    );
  }

  clear(type?: string) {
    this.notifications.forEach((n, i) => {
      if (n.type === type || !type) {
        this.notifications.splice(i, 1);
      }
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
